import apiClient from "../clinet";

// Create new contact-us message
const createContactUs = async (contactData: any) => {
  const response = await apiClient.post("/contactUs", contactData);
  return response.data;
};

export default {
  createContactUs,
};
